import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import styles from './MafaldaDetail.module.css';  // 引入样式模块

// 导入图片
import m_i_img1 from '../../assets/img/m_i_img1.jpg';
import m_i_img2 from '../../assets/img/m_i_img2.jpg';
import m_i_img3 from '../../assets/img/m_i_img3.jpg';
import m_i_img4 from '../../assets/img/m_i_img4.jpg';
import m_i_img5 from '../../assets/img/m_i_img5.jpg';
import m_i_img6 from '../../assets/img/m_i_img6.jpg';
import m_i_img7 from '../../assets/img/640.gif';
import m_e_img1 from '../../assets/img/m_e_img1.jpg';
import m_e_img2 from '../../assets/img/m_e_img2.jpg';
import m_e_img3 from '../../assets/img/m_e_img3.jpg';
import m_e_img4 from '../../assets/img/m_e_img4.jpg';
import m_e_img5 from '../../assets/img/m_e_img5.jpg';

export const MafaldaDetail = () => {
  // Carousel 的响应式配置
  const responsive = {
    superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 5 },
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 3 },
    tablet: { breakpoint: { max: 1024, min: 464 }, items: 2 },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 1 }
  };

  // 第一个模块：产品介绍的卡片内容
  const productContent = [
    { img: m_i_img1, title: "History", description: "Mafalda's historical background." },
    { img: m_i_img2, title: "Apperceive", description: "Mafalda's world" },
    { img: m_i_img3, title: "Memory", description: "Mafalda's memories." },
    { img: m_i_img4, title: "Immersion", description: "Immersive vertical painting." },
    { img: m_i_img5, title: "Interaction", description: "Dinner with Mafalda." },
    { img: m_i_img6, title: "Exhibition", description: "Exhibition three-dimensional device." },
    { img: m_i_img7, title: "Demo", description: "Device demonstration diagram." }
  ];

  // 第二个模块：展览介绍的卡片内容
  const exhibitionContent = [
    { img: m_e_img1, description: "Group photo with the audience" },
    { img: m_e_img2, description: "Group photo with the audience" },
    { img: m_e_img3, description: "Interview with partner" },
    { img: m_e_img4, description: "Public space" },
    { img: m_e_img5, description: "Exhibition venue" }
  ];

  return (
    <div>
      {/* 主题背景图 */}
      <div className={styles.heroImage} style={{ backgroundImage: `url(${m_e_img4})` }}>
        <h2 className={styles.heroTitle}>Welcome to Mafalda's World</h2>
      </div>

      <section className={styles.mafaldaSection}>
        <h2 className={styles.mafaldaTitle}>Project Background</h2>
        <p className={styles.mafaldaText}>
          Argentina is not only about football and tango, but also Mafalda. Mafalda’s creator is the Argentine cartoonist Joaquín Salvador Lavado Tejón, better known by his pen name Quino. Mafalda is a fictional character in his comics. In 1964, Quino first introduced the image of this little girl in a magazine. The Mafalda series ran for about ten years, initially sweeping across Latin America and later spreading worldwide. It has been translated into over 30 languages, including Hebrew, Guaraní, Armenian, and Braille. She is not only beloved by children, but her life and the phenomena within it also reflect the adult world.
        </p>
        <p className={styles.mafaldaText}>
          I “met” the adorable Mafalda through my classmates in the Space and Media Research Group at the Tsinghua University Future Lab. With the help of technologies such as intelligent animation and physical interaction, they collaborated with the Cervantes Institute and the publisher New Thinking to host the exhibition “Welcome to the World of Mafalda — The 60th Anniversary of Mafalda.”
        </p>
        <strong>Year: 2024.9 - 2024.10</strong>
      </section>

      <section className={styles.mafaldaSection}>
        <h2 className={styles.mafaldaTitle}>Product Introduction</h2>
        <p className={styles.mafaldaText}>
          The exhibition used intelligent animation to bring Mafalda to life, enhanced by music and interaction. Visitors could build a 3D Mafalda house with cardboard and interact with the characters, experiencing her daily life and thoughts in an immersive way.
        </p>
        <Carousel responsive={responsive} infinite={true} itemClass="carousel-item">
          {productContent.map((content, index) => (
            <div key={index} className={styles.mafaldaCarouselItem}>
              <img src={content.img} alt={content.title} className={styles.mafaldaCarouselImage} />
              <h5 className={styles.mafaldaCarouselTitle}>{content.title}</h5>
              <p className={styles.mafaldaCarouselText}>{content.description}</p>
            </div>
          ))}
        </Carousel>
      </section>

      <section className={styles.mafaldaSection}>
        <h2 className={styles.mafaldaTitle}>Exhibition</h2>
        <p className={styles.mafaldaText}>
          Through this dynamic, clever approach, design research facilitated international cultural exchange, bringing joy to children this summer. Intelligent animation technology brings classic art to life, recreating and even creating exciting storylines. Audiences can engage deeply with the content through physical interaction, continuing Mafalda’s story around the world.
        </p>
         <Carousel responsive={responsive} infinite={true} itemClass="carousel-item">
          {exhibitionContent.map((content, index) => (
            <div key={index} className={styles.mafaldaCarouselItem}>
              <img src={content.img} alt={content.title} className={styles.mafaldaCarouselImage} />
              <h5 className={styles.mafaldaCarouselTitle}>{content.title}</h5>
              <p className={styles.mafaldaCarouselText}>{content.description}</p>
            </div>
          ))}
        </Carousel>

      </section>
    </div>
  );
};

export default MafaldaDetail;